import { SimpleGrid, Text } from '@chakra-ui/react';
import { FC } from "react";
import { useLoggedinUser, useTeamInvites, useTeamMembers } from "lib/hooks";
import { VerifyEmailAlert } from "components";
import { TeamUserActionProvider } from "./teamUserActionProvider";
import { v4 as uuid } from "uuid";
import { SkeletonTeamUserListingItem } from "./skeletonTeamUserListingItem";
import { TeamUserListingItem } from "./teamUserListingItem";
import { TeamInvite, TeamInviteType, TeamUser } from 'lib/types';
import { TeamUserListingInvite } from './teamUserListingInvite';
import { InviteListingItem } from './inviteListingItem';

const mockElems: null[] = Array(Math.round(Math.random() * (7 - 2 + 1) + 3)).fill(null);

export const TeamUserListing: FC = () => {
  const { data, isLoading: isLoadingMembers } = useTeamMembers();
  const { data: invites, isLoading: isLoadingInvites } = useTeamInvites(); 
  const { isLoading: isLoadingUser, isVerified } = useLoggedinUser();

  if (!isLoadingUser && !isVerified) {
    return (
      <VerifyEmailAlert content={"Verify your email to view team members."} />
    )
  }

  const individualInvites = invites?.filter((invite: TeamInvite) => invite.type === TeamInviteType.INDIVIDUAL);
  const isLoading = isLoadingMembers || isLoadingInvites;

  const members: TeamUser[] = !isLoading ? data : mockElems;

  return (
    <TeamUserActionProvider>
      <SimpleGrid columns={1} spacing={3}>
        <TeamUserListingInvite />
        {!isLoading && individualInvites.map((invite: any) => (
          <InviteListingItem key={invite.id} invite={invite} />
        ))}
        {members.map((member: TeamUser) => (
          !isLoading
            ? <TeamUserListingItem key={member.user.id} member={member} />
            : <SkeletonTeamUserListingItem key={uuid()} />
        ))}
      </SimpleGrid>
    </TeamUserActionProvider>
  )
}